import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  ModalResponsive,
  Loading,
  LoadingCircle,
  Pagination,
  UsersCard,
  Tooltip,
} from '../../../components';
import Edit from '../../../assets/buttons/edit.svg';
import Analisys from '../../../assets/buttons/analisys.svg';
import Deactivate from '../../../assets/buttons/deactivate.svg';
import Reactivate from '../../../assets/buttons/reactivate.svg';
import GroupAdd from '../../../assets/buttons/group-add.svg';
import { useAccess, useClient } from '../../../hooks';
import {
  searchArrayOfObjects,
  sendNotification,
  formatDocumentCNPJ,
} from '../../../utils/functions';
import makeAnimated from 'react-select/animated';
import { usePermissions } from '../../../hooks/usePermissions';
import { WithContext as ReactTags } from 'react-tag-input';

import { FaRegCircleQuestion } from 'react-icons/fa6';
import { MdOutlineEdit } from 'react-icons/md';
import { Container, Content } from '../../../styles/lib/grid';
import { TabsContainer } from '../../../styles/lib/tabs';
import * as S from '../../AccessControl/Users/UsersStyles';

import ValidationUserDialog from './Components/ValidationUser/ValidationDialog';
import { Select, Option } from '../../../styles/lib/dynamic-filter';
import { IProfileGroup } from '../../../interfaces/permissions';
import { AxiosResponse } from 'axios';
import { usePagination } from '../../../hooks/usePagination';
import useDealer from '../../../hooks/useDealer/useDealer';

const toastConfig = {
  autoClose: 3000,
  hideProgressBar: true,
  type: 'success',
};

export const Dealers: React.FC = () => {
  const {
    returnAllDealers,
    changeUserStatus,
    editUserInfo,
    analyzeUser,
    isLoading,
    isLoadingAPICall,
    dealers,
    metadata,
  } = useDealer();

  const [
    { profileGroups, responsibleChannel },
    ,
    ,
    ,
    ,
    ,
    fetchResponsibleChannel,
  ] = usePermissions();

  const [apiError, setApiError] = useState<string | null>(null);

  const [area, setArea] = useState<any>([]);
  const [profile, setProfile] = useState('');
  const [cnpjsRaiz, setCnpjsRaiz] = useState<any>([]);
  const [{ reject }, consultingCnpj] = useClient();

  const [openEditModal, setOpenEditModal] = useState(false);
  const [openAnalysisModal, setOpenAnalysisModal] = useState(false);
  const [openAnalysisModalRevendedor, setOpenAnalysisModalRevendedor] =
    useState(false);
  const [openReactivateModal, setOpenReactivateModal] = useState(false);
  const [openDeactivateModal, setOpenDeactivateModal] = useState(false);
  const [openRegisterModal, setOpenRegisterModal] = useState(false);

  const [filters, setFilters] = useState<{
    type: string;
    term: string;
    tipoPerfil: string;
  }>({
    type: '',
    term: '',
    tipoPerfil: '',
  });

  const [user, setUser] = useState<any>(null);
  const [isApprove, setIsApprove] = useState(true);
  const [reproveReason, setReproveReason] = useState('');
  const [editDealer, setEditDealer] = useState(false);

  useEffect(() => {
    fetchResponsibleChannel();
    handleAllUsers();
    setApiError(null);
  }, []);

  const animatedSelectComponents = makeAnimated();

  useEffect(() => {
    if (!openEditModal) {
      setCnpjsRaiz([]);
    } else {
      patchCnpjsRaiz(user);
    }
  }, [openEditModal]);

  const profileTypes = useMemo(() => {
    return profileGroups.map((e: any) => {
      return e;
    });
  }, [profileGroups]);

  const handleAreaChoosen = (area: any, user: any) => {
    setUser({ ...user, areasAtuacao: area });
    setArea(area);
  };

  const deactivateUser = async () => {
    await changeUserStatus(user?.id, false);
    sendNotification(
      `O usuário ${user?.razaoSocial} foi desativado.`,
      toastConfig,
    );
    setOpenDeactivateModal(false);
    handleAllUsers();
  };

  const activateUser = async () => {
    await changeUserStatus(user?.id, true);
    sendNotification(
      `O usuário ${user?.razaoSocial} foi reativado.`,
      toastConfig,
    );
    setOpenReactivateModal(false);

    handleAllUsers();
  };

  const { currentPage, pageSize, handlePageChange, resetPagination } =
    usePagination({
      totalItems: dealers.pagination?.totalItems || 0,
      onPageChange: (currentPage, pageSize) => {
        returnAllDealers({
          ...filters,
          currentPage,
          pageSize,
          isNew: false,
        });
      },
    });

  const handleAllUsers = () => {
    resetPagination();
    returnAllDealers({
      ...filters,
      pageSize,
      currentPage: 1,
      isNew: false,
    });
  };

  const searchUsers = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleAllUsers();
  };

  const handleModalClose = async () => {
    setOpenRegisterModal(false);
    handleAllUsers();
  };

  const handleUserAction = async (
    actionFn: () => Promise<AxiosResponse | undefined>,
    successMessage: string,
    errorMessage?: string,
  ) => {
    try {
      await actionFn();
      sendNotification(successMessage, toastConfig);
      setOpenAnalysisModal(false);
      setOpenEditModal(false);
      setReproveReason('');
      setApiError(null);
    } catch (e: any) {
      const errorToDisplay =
        errorMessage || e.response?.data?.errors || e.message;
      setApiError(errorToDisplay);
    }
  };

  const patchCnpjsRaiz = (user: any) => {
    if (!user || !user.cnpj) {
      return;
    }

    const cnpjs = Array.isArray(user.cnpj)
      ? user.cnpj
      : typeof user.cnpj === 'string'
      ? [user.cnpj]
      : [];

    const existingCnpjs = new Set(
      cnpjsRaiz.map((cnpj: { id: string; text: string }) => cnpj.id),
    );

    const uniqueFormattedCnpjs = cnpjs
      .filter((cnpj: any) => !existingCnpjs.has(cnpj))
      .map((cnpj: any) => ({
        id: cnpj,
        text: formatCnpj(cnpj),
      }));

    setCnpjsRaiz((prevCnpjsRaiz: any) => {
      const updatedCnpjs = [...prevCnpjsRaiz, ...uniqueFormattedCnpjs];
      const uniqueCnpjs = Array.from(new Set(updatedCnpjs.map(c => c.id))).map(
        id => updatedCnpjs.find(c => c.id === id),
      );

      return uniqueCnpjs;
    });
  };

  const formatCnpj = (cnpj: string) => {
    if (typeof cnpj !== 'string') {
      return cnpj;
    }
    return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(
      5,
      8,
    )}/${cnpj.slice(8, 12)}-${cnpj.slice(12, 14)}`;
  };

  const isRevendedor = (perfil: string) => {
    return perfil === 'revendedor-allied';
  };

  const treatmentUserAttributes = (user: any) => {
    setUser(user);
    setProfile(user.perfil?.nome);
    setArea(null);
    if (user?.canaisResponsaveis?.length > 0) {
      const canaisResponsaveis: any = user?.canaisResponsaveis.map((r: any) => {
        const matchingGroup: any = responsibleChannel.find(
          (area: any) => area.label === r,
        );
        const value = matchingGroup ? matchingGroup.value : null;
        return {
          value,
          label: r,
        };
      });
      setArea(canaisResponsaveis);
    } else {
      setArea([]);
    }
  };

  const renderdealers = (dealers: any) => {
    const cadastrados = dealers?.filter(
      (representante: any) => representante?.analisado,
    );

    return (
      <>
        <h2>Cadastrados</h2>
        <hr style={{ margin: '10px 0 20px 0' }} />
        {cadastrados?.map((elm: any) => (
          <UsersCard key={elm?.id} user={elm}>
            <S.CardButtons>
              {!elm?.analisado && (
                <S.IconButton
                  className="analisys"
                  onClick={() => {
                    setOpenAnalysisModal(true);
                    setIsApprove(true);
                    setApiError(null);
                    treatmentUserAttributes(elm);
                  }}
                >
                  <img src={Analisys} width={16} />
                  Analisar
                </S.IconButton>
              )}
              {elm?.ativo && elm?.analisado && (
                <S.IconButton
                  className="deactivate"
                  onClick={() => {
                    setOpenDeactivateModal(true);
                    setUser(elm);
                  }}
                >
                  <img src={Deactivate} width={16} />
                  Desativar
                </S.IconButton>
              )}
              {!elm?.ativo && elm?.analisado && (
                <S.IconButton
                  className="reactivate"
                  onClick={() => {
                    setOpenReactivateModal(true);
                    setUser(elm);
                  }}
                >
                  <img src={Reactivate} width={16} />
                  Reativar
                </S.IconButton>
              )}
              <S.IconButton
                className={!elm.analisado ? 'edit disabled' : 'edit'}
                onClick={() => {
                  setApiError(null);
                  treatmentUserAttributes(elm);
                  if (!isRevendedor(elm?.perfil?.nome)) {
                    setOpenEditModal(true);
                  } else {
                    setEditDealer(true);
                    setOpenAnalysisModalRevendedor(true);
                  }
                }}
                disabled={!elm?.analisado}
              >
                <MdOutlineEdit color="#FFFFFF" size={16} />
                Editar
              </S.IconButton>
            </S.CardButtons>
          </UsersCard>
        ))}
      </>
    );
  };

  return (
    <Container>
      <Content>
        <S.SearchWrapper>
          <S.SearchCell>
            <S.Search onSubmit={searchUsers}>
              <S.InputContainer>
                <S.Select
                  value={filters.type}
                  className="floating"
                  onChange={(e: any) => {
                    setFilters(prev => ({
                      ...prev,
                      type: e.target.value,
                      term: '',
                    }));
                  }}
                >
                  <S.Option value="">Selecione</S.Option>
                  <S.Option value="cnpj">CNPJ</S.Option>
                  <S.Option value="razao">Nome / Razão Social</S.Option>
                  <S.Option value="email">E-mail</S.Option>
                </S.Select>
                <S.Input
                  maxLength={35}
                  value={filters.term}
                  onChange={(e: any) =>
                    setFilters(prev => ({
                      ...prev,
                      term:
                        prev.type === 'cnpj'
                          ? formatDocumentCNPJ(e.target.value)
                          : e.target.value,
                    }))
                  }
                  placeholder={'Faça sua busca...'}
                />
              </S.InputContainer>

              <S.ButtonsContainer>
                <S.Button type="submit">Buscar</S.Button>
              </S.ButtonsContainer>
            </S.Search>
          </S.SearchCell>

          <S.CardInfo>
            <S.CardCell className="left">
              <S.CardText className="active">Ativos</S.CardText>
              <p>
                <S.CardText className="bolder">
                  {metadata.totalAtivos ?? '-'}/
                </S.CardText>
                <S.CardText className="smallest">
                  {metadata.total ?? '-'}
                </S.CardText>{' '}
                <S.CardText className="info">revendedores</S.CardText>
              </p>
            </S.CardCell>
            <S.CardCell>
              <S.CardText className="inactive">Inativos</S.CardText>
              <p>
                <S.CardText className="bolder">
                  {metadata.totalInativos ?? '-'}/
                </S.CardText>
                <S.CardText className="smallest">
                  {metadata.total ?? '-'}
                </S.CardText>{' '}
                <S.CardText className="info">revendedores</S.CardText>
              </p>
            </S.CardCell>
          </S.CardInfo>
        </S.SearchWrapper>

        <TabsContainer>
          {isLoading ? <Loading /> : renderdealers(dealers.representantes)}
        </TabsContainer>

        {!isLoading && dealers.representantes?.length === 0 && (
          <S.Message>Nenhum resultado encontrado.</S.Message>
        )}

        {!isLoading && dealers.representantes?.length !== 0 && (
          <Pagination
            currentPage={currentPage}
            paginationSize={pageSize}
            onPageChange={handlePageChange}
            totalItems={dealers.pagination?.totalItems}
          />
        )}
      </Content>

      <>
        <ValidationUserDialog
          isOpen={openAnalysisModalRevendedor}
          user={user}
          onClose={() => {
            setOpenAnalysisModalRevendedor(false);
            handleAllUsers();
          }}
          allowEdit={editDealer}
        />
      </>

      <ModalResponsive
        title={'Reativação de usuário'}
        isOpenModal={openReactivateModal}
        handleOpenModal={setOpenReactivateModal}
      >
        <S.Text>
          Você está reativando o usuário{' '}
          <S.Text className="bold inline">
            {user?.nome ?? user?.nomeContato ?? user?.razaoSocial}
          </S.Text>
          . Essa ação concederá o acesso ao sistema. Deseja continuar?
        </S.Text>
        <S.Buttons>
          <S.IconButton
            className="text"
            onClick={() => setOpenReactivateModal(false)}
          >
            Cancelar
          </S.IconButton>
          <S.IconButton
            className="success"
            onClick={activateUser}
            disabled={isLoadingAPICall}
          >
            {isLoadingAPICall ? <LoadingCircle /> : 'Ativar'}
          </S.IconButton>
        </S.Buttons>
      </ModalResponsive>

      <ModalResponsive
        title={'Desativação de usuário'}
        isOpenModal={openDeactivateModal}
        handleOpenModal={setOpenDeactivateModal}
      >
        <S.Text>
          Você está desativando o usuário{' '}
          <S.Text className="bold inline">
            {user?.nome ?? user?.nomeContato ?? user?.razaoSocial}
          </S.Text>
          . Essa ação bloqueará o acesso ao sistema. Deseja continuar?
        </S.Text>
        <S.Buttons>
          <S.IconButton
            className="text"
            onClick={() => setOpenDeactivateModal(false)}
          >
            Cancelar
          </S.IconButton>
          <S.IconButton
            className="danger"
            onClick={deactivateUser}
            disabled={isLoadingAPICall}
          >
            {isLoadingAPICall ? <LoadingCircle /> : 'Desativar'}
          </S.IconButton>
        </S.Buttons>
      </ModalResponsive>

      <ToastContainer
        closeButton={false}
        transition={Slide}
        position="bottom-center"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Container>
  );
};
